import styled from 'vue-styled-components'

const StyledCheckbox = styled.div`
  position: relative;
  padding-left: 24px;
`

const StyledCheckboxInput = styled.input`
  display: none;
`

const propsLabel = {
  checked: Boolean
}

const StyledCheckboxLabel = styled('label', propsLabel)`
    display: inline-block;
    margin-top: -2px;
    color: ${props => props.theme.colors.black};
    font-family: 'Gilroy';
    font-size: 0.875rem;
    line-height: 1.25rem;
    
    &:before, &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
    
    &:before {
      background-color: ${props => props.theme.colors.white};
      border: 1px solid ${props => props.theme.colors.disable};
      border-radius: 1px;
    }
    
    &:after {
      content: ${props => props.checked && 'url("../static/img/svg/check.svg")'}
    }
    
    &:hover {
      &:before {
        background-color: #f7f8fa;
      }
    }
    
    > a {
      text-decoration: none;
    }
`

const StyledCheckboxDescription = styled.span`
  margin-top: 8px;
  color: #c6c8cc;
`

export {
  StyledCheckbox,
  StyledCheckboxInput,
  StyledCheckboxLabel,
  StyledCheckboxDescription
}



// WEBPACK FOOTER //
// ./src/components/Checkbox/StyledCheckbox.js